import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=37480ebc&scoped=true&"
var script = {}
import style0 from "./filter.vue?vue&type=style&index=0&id=37480ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37480ebc",
  null
  
)

export default component.exports